import React from "react";
import "./style.scss";

export const Label = ({
  version = "1",
  weight = "regular",
  children,
  ...props
}) => {
  return (
    <label
      className={`ldsrf-label version-${version} weight-${weight}`}
      {...props}
    >
      {children}
    </label>
  );
};
